export default {
  apiGateway: {
    REGION: "eu-west-1",
    URL: process.env.REACT_APP_API_URI
    //URL: "https://webapi.4gflota.com/api/"
    //URL: "https://4yahqnkrsh.execute-api.eu-west-1.amazonaws.com/Prod/api/"  //desarrollo
  },
  KeyGoogleMaps: 'AIzaSyDXhVYV0tKNy9kgA6mdHKX2F2H8LlbGnhk'
};